export { AppMessageType } from '../modules/app-messages/app-messages.enums';
export {
  SpotPricePeriod,
  SpotRegion,
  Currency,
} from '../modules/spot/spot.types';

export { FlexibilityCommandType } from '../modules/flexibility-api/flexibility-api.types';

export enum Inverter {
  GoodWe = 1,
  Solax = 2,
  Sofarsolar = 3,
  SolaxGrid = 4,
  GoodWeGrid = 5,
  Next = 'next',
  GoodWeNext = 'good-we',
  GoodWeGridNext = 'good-we-grid',
  SolaxNext = 'solax',
  SolaxEMS1000 = 'solax-ems1000',
  SolaxEMS1000PRO = 'solax-ems1000pro',
  SolaxMICGrid = 'solax-mic-grid',
  SolaxMEGAGrid = 'solax-mega-grid',
  Victron = 'victron',
  SofarSolarRS485 = 'sofar-solar-rs485',
  Solinteg = 'solinteg',
  Shellies = 'shellies',
  ShelliesExternal = 'shellies-external',
  Hes = 'hes',
  ThreeMarPLC = '3mar-plc',
  Sermatec = 'sermatec',
  Deye = 'deye',
  DeyeHV = 'deye-hv',
  Wattsonic = 'wattsonic',
  Fronius = 'fronius',
  FroniusGrid = 'fronius-grid',
  FroniusVerto = 'fronius-verto',
  SolarEdgeGrid = 'solar-edge-grid',
  SmaGrid = 'sma-grid',
  AzRouter = 'az-router',
  DesBatteryContainer = 'des-battery-container',
  None = 'none',
}

export enum OemDistribution {
  Infigy = 1,
  DZD = 2,
  Solidsun = 'solidsun',
}

export enum License {
  Basic = 1,
  HW = 2,
  SMART = 3,
  PLAY = 4,
  INDUSTRIAL = 5,
}

export enum HeatPump {
  Ecoone = 1,
  Nibe = 2,
  NibeF = 3,
  Acond = 4,
}

export enum HeatPumpStatus {
  Heating = 'heating',
  HotWater = 'hot-water',
  Cooling = 'cooling',
  Pool = 'pool',
  Inactive = 'inactive',
  NotConnected = 'not-connected',
  CompressorBlocked = 'compressor-blocked',
  NotLicensed = 'not-licensed',
}

export enum HeatPumpInfoStatus {
  None = 'none',
  ConsumptionRise = 'consumption-rise',
  ConsumptionPostpone = 'consumption-postpone',
  ConsumptionWithFlexibility = 'consumption-with-flexibility',
  NibeNotWritable = 'nibe-not-writable',
}

export enum SmartMeterStatus {
  None = 'none',
  Consumption = 'consumption',
  Overflow = 'overflow',
  OverflowLimited = 'overflow-limited',
  MaxLoad = 'max-load',
  Shortage = 'shortage',
}

export enum HeatWaterStatus {
  Stop = 'stop',
  Legionella = 'legionella',
  Heating = 'heating',
  Flexibility = 'flexibility',
  SpotHeating = 'spot-heating',
  NotConnected = 'not-connected',
  Overload = 'overload',
  StopSell = 'stop-sell',
  StopHDO = 'stop-hdo',
  StopSOC = 'stop-soc',
  HWError = 'hw-error',
  TempError = 'temp-error',
  InverterError = 'inverter-error',
  SmartMeterError = 'smart-meter-error',
  PVHeating = 'pv-heating',
  NotLicensed = 'not-licensed',
  Off = 'off',
}

export enum PhotovoltaicStatus {
  Standby = 'stand-by-mode',
  Production = 'production',
  StartUp = 'start-up-mode',
  Discharging = 'discharging',
  SpotCharging = 'spot-charging',
  ManualCharging = 'manual-charging',
  ManualDischarging = 'manual-discharging',
  SpotStopDischarging = 'spot-stop-discharging',
  FlexibilityCharging = 'flexibility-charging',
  FlexibilityDischarging = 'flexibility-discharging',
  FlexibilityFeedInPriority = 'flexibility-feed-in-priority',
  FlexibilityDoNotDischarge = 'flexibility-do-not-discharge',
  FlexibilityBatteryStop = 'flexibility-battery-stop',
  FlexibilityOverflowRestricted = 'flexibility-overflow-restricted',
  FeedInPriority = 'feed-in-priority',
  PlanCharge = 'plan-charge',
  PlanDischarge = 'plan-discharge',
  NotConnected = 'not-connected',
  Idle = 'idle-mode',
  SellBatteryEnergy = 'sell-battery-energy',
  NotLicensed = 'fve-control-not-licensed',
  NoneInverter = 'inverter-type-not-set',
  DistributionLimit = 'distribution-limit',
  ForcedOverflow = 'forced-overflow',
  StopDischargingComponents = 'stop-discharging-components',
  DischargeBlockedByHDO = 'discharge-blocked-by-hdo',
  DischargeBlockedByComponents = 'discharge-blocked-by-components',
}

export enum PlugStatus {
  STOP = 'stop',
  BatteryControl = 'battery-control',
  SpotControl = 'spot-control',
  TimeControl = 'time-control',
  OverflowControl = 'overflow-control',
  ManualControl = 'manual-control',
  NotConnected = 'not-connected',
  NotActive = 'not-active',
}

export enum SpotBatteryStatus {
  FlexibilityPV = 'flexibility-pv',
  FlexibilitySpot = 'flexibility-spot',
  NoData = 'no-data',
  SpotNotLicensed = 'spot-not-licensed',
}

export enum SpotBatteryDischargeToGridStatus {
  SpotNotActive = 'spot-not-active',
  BatteryDischargingNotActive = 'battery-discharging-not-active',
  MinPriceNotReached = 'min-price-not-reached',
  NotEnoughBatteryEnergy = 'not-enough-battery-energy',
  BatteryDischargingPlanned = 'battery-discharging-planned',
}

export enum SpotBatteryDischargeToHomeStatus {
  AutomaticDischargeMode = 'automatic-discharge-mode',
  HighPriceDischargeMode = 'high-price-discharge-mode',
  MediumAndHighPriceDischargeMode = 'medium-and-high-price-discharge-mode',
  NotControlled = 'not-controlled',
}

export enum SpotBatteryChargeFromGridStatus {
  SpotNotActive = 'spot-not-active',
  BatteryChargingNotActive = 'battery-charging-not-active',
  PriceDifferenceTooLow = 'price-difference-too-low',
  EnoughPVEnergy = 'enough-pv-energy',
  BatteryChargingPlanned = 'battery-charging-planned',
}

export enum SpotHeatPumpStatus {
  FlexibilityPV = 'flexibility-pv',
  FlexibilitySpot = 'flexibility-spot',
  NoData = 'no-data',
  SpotNotLicensed = 'spot-not-licensed',
}

export enum SpotHeatWaterStatus {
  FlexibilityPV = 'flexibility-pv',
  FlexibilitySpot = 'flexibility-spot',
  NoData = 'no-data',
  SpotNotLicensed = 'spot-not-licensed',
}

export enum SpotSmartMeterStatus {
  NoData = 'no-data',
  SpotNotLicensed = 'spot-not-licensed',
  WithoutReduction = 'without-reduction',
  OverflowFlexibilitySell = 'overflow-flexibility-sell',
  OverflowDisabled = 'overflow-disabled',
  OverflowLimited = 'overflow-limited',
}

export enum WallboxStatus {
  NotConnected = 'not-connected',
  Off = 'off',
  Normal = 'normal',
  CarNotConnected = 'car-not-connected',
  Ready = 'ready',
  Charging = 'charging',
  ChargingWithVentilation = 'charging-with-ventilation',
  Error = 'error',
}

export enum WallboxSubStatus {
  None = 'none',
  BasicEnergy = 'basic-energy',
  BatteryWaiting = 'battery-waiting',
  Battery = 'battery',
  Photovoltaics = 'photovoltaics',
  Spot = 'spot',
  SpotMid = 'spot-mid',
  SpotHigh = 'spot-high',
  Auto = 'auto',
  HDOBlock = 'hdo-block',
  BatteryFast = 'battery-fast',
  Schedule = 'schedule',
  NoCharging = 'no-charging',
}

export enum RfidReader {
  Inveo = 'inveo',
}

export enum AzRouter {
  V1 = 'v1',
}

export enum Wallbox {
  None = 0,
  Solax = 1,
  EvMate = 2,
  MyBox = 3,
  VictronEvCharger = 4,
  SolaxEvCharger = 5,
  Olife = 'olife',
  GoodweEvCharger = 'goodwe',
  Alfen = 'alfen',
  Ecovolter = 'ecovolter',
  Next = 'next',
  AzRouter = 'az-router',
}

export enum WindStatus {
  Production = 'production',
  Stop = 'stop',
  Unavailable = 'unavailable',
}

export enum HeatWater {
  Proportional = 1,
  Digital = 2,
}

export enum FlexibilityType {
  Stop = 1,
  Up = 2,
  Down = 3,
}

export enum AppUiVariant {
  Default = 'default',
  Ryse = 'ryse',
  Innogy = 'innogy',
  Solidsun = 'solidsun',
}

export enum Board {
  V1 = 'v1',
  V2 = 'v2',
  Play = 'play',
  SunBerry = 'sunberry',
}

export enum RelayControl {
  None = 'none',
  Plug1 = 'plug1',
  Plug2 = 'plug2',
  Plug3 = 'plug3',
  Plug4 = 'plug4',
  SpotLow = 'spot-low',
  SpotHi = 'spot-hi',
  SpotMi = 'spot-mi',
  SpotNegative = 'spot-negative',
  SpotPriceBelow = 'spot-price-below',
  SpotPriceAbove = 'spot-price-above',
  SpotHi15M = 'spot-hi-15m',
  SpotMi15M = 'spot-mi-15m',
  SpotLow15M = 'spot-low-15m',
  SpotNegative15M = 'spot-negative-15m',
  SpotPriceBelow15M = 'spot-price-below-15m',
  SpotPriceAbove15M = 'spot-price-above-15m',
  HDO = 'hdo',
  BatteryFull = 'battery-full',
  BatteryLow = 'battery-low',
  BatteryBelowSOC = 'battery-below-soc',
  HeatWaterMaxTemp = 'heat-water-max-temp',
  HeatWaterAboveTemp = 'heat-water-above-temp',
  HeatWaterBelowTemp = 'heat-water-below-temp',
  Thermostat1 = 'thermostat1',
  Thermostat2 = 'thermostat2',
  Thermostat3 = 'thermostat3',
  Thermostat4 = 'thermostat4',
  SpotBatteryDischarge = 'spot-battery-discharge',
  SpotStopAccumulation = 'spot-stop-accumulation',
  Active = 'active',
}

export enum Operator {
  None = 'none',
  And = 'and',
  Or = 'or',
  AndNot = 'andNot',
  OrNot = 'orNot',
}

export enum StatsMetric {
  PV_POWER_GRAPH = 'pv-power-graph',
  PV_POWER_STRING_GRAPH = 'pv-power-string-graph',
  HW_POWER_GRAPH = 'hw-power-graph',
  HW_POWER_PHASE_GRAPH = 'hw-power-phase-graph',
  HP_CONSUMED_GRAPH = 'hp-consumed-graph',
  EM_CONSUMED_GRAPH = 'em-consumed-graph',
  EM_CONSUMED_PHASE_GRAPH = 'em-consumed-phase-graph',
  EM_OVERFLOW_GRAPH = 'em-overflow-graph',
  EM_OVERFLOW_PHASE_GRAPH = 'em-overflow-phase-graph',
  PL_POWER_GRAPH = 'pl-power-graph',
  WB_CONSUMED_GRAPH = 'wb-consumed-graph',
  PV_BATTERY_SOC_GRAPH = 'pv-battery-soc-graph',
  PV_BATTERY_CHARGE_GRAPH = 'pv-battery-charge-graph',
  PV_BATTERY_DISCHARGE_GRAPH = 'pv-battery-discharge-graph',
  HW_TEMP_GRAPH = 'hw-temp-graph',
  THERMOSTAT_TEMP_GRAPH = 'thermostat-temp-graph',
  OUTDOOR_TEMP_GRAPH = 'outdoor-temp-graph',
  WIND_POWER_GRAPH = 'wind-power-graph',
  WIND_BATTERY_CHARGE_POWER_GRAPH = 'wind-battery-charge-power-graph',
  WIND_SPEED_GRAPH = 'wind-speed-graph',
  WIND_LOAD_CURRENT_GRAPH = 'wind-load-current-graph',
  HOME_CONSUMPTION = 'home-consumption',
  EM_METER_POWER_GRAPH = 'em-meter-power-graph',
  EM_METER_POWER_PHASE_GRAPH = 'em-meter-power-phase-graph',
}
export enum SpotPriceLevel {
  Low = 'low',
  Mid = 'middle',
  Hi = 'hi',
}

export enum HpLevel {
  Increase = 'increase',
  Normal = 'normal',
  Reduction = 'reduction',
}

export enum ThermostatFlexibilityLevel {
  IncreasePv = 'Flxibilita využita pro zvýšení teploty dle fotovoltaiky',
  IncreaseSpot = 'Flexibilita využita pro zvýšení teploty dle SPOTU',
  Normal = 'Normální',
  ReductionSpot = 'Flexibilita využita pro snížení teploty dle SPOTU',
}
export enum ThermostatLevel {
  Deactivated = 'Neaktivní',
  Heating = 'Vytápění',
  Cooling = 'Chlazení',
  StandBy = 'StandBy',
  TempErr = 'Chyba teploty',
}

export enum LicenseExtension {
  Hw = 'hw',
  Thermostat = 'thermostat',
}

export enum FlexibilityCommandBattery {
  Default = 'default',
  ChargeFromGrid = 'charge_from_grid',
  DoNotCharge = 'do_not_charge',
  DoNotDischarge = 'do_not_discharge',
  DischargeToGrid = 'discharge_to_grid',
  Stop = 'stop',
}

export enum EnergomachineBatteryMode {
  Auto = 'AUTO',
  Stop = 'OFF',
  ManualIn = 'MANUAL_IN',
  ManualOut = 'MANUAL_OUT',
  DischargeDisabled = 'DISCHARGE_DISABLED',
  ChargeDisabled = 'CHARGE_DISABLED',
}

export enum FlexibilityCommandPv {
  Unrestricted = 'unrestricted',
  FullyRestricted = 'fully_restricted',
  RestrictedToHousehold = 'restricted_to_household',
  ForcedOverflow = 'forced_overflow',
}

export enum ConnectionType {
  ModbusTCP = 'modbus-tcp',
  RS485 = 'rs485',
}

export enum NetworkType {
  External = 'external',
  Internal = 'internal',
  Custom = 'custom',
}

export const boardsWithInternalNetwork = [Board.V2];

/** Inverter types that can be wired to the board's RS485 bus instead of Modbus TCP. */
export const invertersSupportingRS485 = [
  Inverter.Solax,
  Inverter.SolaxMICGrid,
  Inverter.SolaxMEGAGrid,
  Inverter.GoodWe,
  Inverter.GoodWeNext,
  Inverter.SolaxNext,
  Inverter.GoodWeGridNext,
  Inverter.Deye,
  Inverter.DeyeHV,
  Inverter.Solinteg,
  Inverter.Wattsonic,
  Inverter.Sermatec,
  Inverter.DesBatteryContainer,
];

export enum MqttCloudDeviceType {
  ShellyPlusPlugS = 'shelly-plus-plug-s',
  ShellyPlusPlugSGen3 = 'shelly-plus-plug-s-gen3',
  ShellyPlugMGen3 = 'shelly-plug-m-gen3',
  Shelly1PMGen3 = 'shelly-1pm-gen3',
  Shelly1PMGen4 = 'shelly-1pm-gen4',
  ShellyPlus1PM = 'shelly-plus-1pm',
  ShellyPro1PM = 'shelly-pro-1pm',
  ShellyPro1PMGen3 = 'shelly-pro-1pm-gen3',
  ShellyPro3EM = 'shelly-pro-3-em',
}

export enum OverflowLimitType {
  None = 'none',
  ExportLimit = 'export-limit',
  SpotLimit = 'spot-limit',
  FlexibilityLimit = 'flexibility-limit',
}

// Utility billing metering mode - per phase in the Czech Republic, netted (sum) elsewhere
export enum GridMeteringMode {
  PerPhase = 'per-phase',
  Sum = 'sum',
}

export enum GraphControlMode {
  Photovoltaic = 'photovoltaic',
  Grid = 'grid',
  Spot = 'spot',
  Flexibility = 'flexibility',
  Error = 'error',
}

export enum PlugActiveCondition {
  Off = 'off',
  Manual = 'manual',
  Time = 'time',
  Battery = 'battery',
  Overflow = 'overflow',
  Spot = 'spot',
  Error = 'error',
}

export enum HDOMode {
  Regular = 1,
  Weekend = 2,
}

export enum SolaxEMS1000InverterName {
  NotConnected = 0,
  TRENE100KI = 1,
  AELIO = 2,
  TRENE100K = 3,
  TRENE125K = 4,
}

export enum SolaxEMS1000PROInverterName {
  NotConnected = 0,
  TRENE1 = 1,
  AELIO = 2,
  TRENE100K = 3,
  TRENE125K = 4,
  X3PROG2 = 16,
  X3FORTH = 100,
  X3MGAG2 = 101,
  X3GRAND = 104,
  X3FORTHPLUS = 105,
}

export enum SolaxMode {
  SelfUse = 1,
  FeedIn = 2,
  Backup = 3,
  Manual = 4,
  PeakShaving = 5,
}

export enum InverterPowerControl {
  Proportional = 1,
  Fixed = 2,
}

export enum InverterControlMode {
  DischargingToGrid = 'discharging-to-grid',
  ChargingFromGrid = 'charging-from-grid',
  StopCharging = 'stop-charging',
  StopDischarging = 'stop-discharging',
  StopOverflow = 'stop-overflow',
}

export enum DesBatteryStatus {
  NONE = 'none',
  RUN = 'run',
  OFF = 'off',
  SLEEP = 'sleep',
  ERROR = 'error',
}
